import {z} from 'zod';

export const ImportFileTypeSchema = z.enum(['carisSaleVehicleCosts', 'as3SaleVehicleCosts']);
export type ImportFileType = z.infer<typeof ImportFileTypeSchema>;

export const CreateImportRequestBodySchema = z.object({
  fileId: z.string(),
  fileType: ImportFileTypeSchema,
});
export type CreateImportRequestBody = z.infer<typeof CreateImportRequestBodySchema>;

export const ImportResponseBodySchema = z.object({
  id: z.string(),
  fileId: z.string(),
  status: z.enum(['created', 'scheduled', 'inProgress', 'finished', 'failed']),
  fileType: ImportFileTypeSchema,
  fileName: z.string(),
  fileUri: z.string(),
  fileContentType: z.string().nullable(),
  name: z.string(),
  description: z.string(),
  message: z.string().nullable(),
  createdAt: z.string(),
  startedAt: z.string().nullable(),
  finishedAt: z.string().nullable(),
  affectedRecordCount: z.number(),
  errorCount: z.number(),
});
export type ImportResponseBody = z.infer<typeof ImportResponseBodySchema>;

export const CreateImportApiArgSchema = z.object({
  body: CreateImportRequestBodySchema,
});
export type CreateImportApiArg = z.infer<typeof CreateImportApiArgSchema>;

export const GetImportApiArgSchema = z.object({
  id: z.string(),
});
export type GetImportApiArg = z.infer<typeof GetImportApiArgSchema>;

export const CreateImportApiResponseSchema = z.unknown();
export type CreateImportApiResponse = z.infer<typeof CreateImportApiResponseSchema>;

export const GetImportApiResponseSchema = ImportResponseBodySchema;
export type GetImportApiResponse = z.infer<typeof GetImportApiResponseSchema>;
